/**
 * useTRLs — subscribe to real-time Hugo_TRLs filtered by the active persona scope.
 *
 * Returns { trls, loading, error, stats } where trls is automatically narrowed
 * to what the active persona is allowed to see (ITM sees own; FLS sees their NWT;
 * DH sees their dept; Site/Exec see broader rollups; Admin/PPI see all).
 */

import { useEffect, useState } from 'react';
import { useDemoRole } from '../../../contexts/DemoRoleContext';
import { subscribeToTRLs, computeTRLStats } from '../../../services/trlService';

export function useTRLs({ status, limit = 100 } = {}) {
  const { queryScope } = useDemoRole();
  const [trls, setTrls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    let unsub;
    try {
      unsub = subscribeToTRLs(
        queryScope,
        (items) => {
          setTrls(items);
          setLoading(false);
        },
        {
          status,
          limit,
          onError: (err) => {
            setError(err);
            setLoading(false);
          },
        }
      );
    } catch (err) {
      console.error('useTRLs: subscription failed', err);
      setError(err);
      setLoading(false);
    }

    return () => {
      if (typeof unsub === 'function') unsub();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    queryScope.personaId,
    queryScope.userId,
    queryScope.nwtId,
    queryScope.deptId,
    queryScope.siteId,
    queryScope.organizationId,
    status,
    limit,
  ]);

  const stats = computeTRLStats(trls);
  return { trls, loading, error, stats };
}
